export enum AnalysisTypeEnum {
  CAPTURE = 'capture',
  ANALYSIS = 'analysis',
  WINDOW = 'window',
}

export default AnalysisTypeEnum
